import 'Main/vue';
import InitComponent from 'Main/modules/InitComponent';
import SearchForm from './components/searchbar/SearchForm.vue';

const searchForms = document.querySelectorAll(
  '#masthead .lavendla-search__wrapper'
);
const initComponent = new InitComponent({
  selectors: searchForms,
  components: { SearchForm },
  template: '<SearchForm />',
});

initComponent.init();
